// @ts-nocheck
import Vue from 'vue'
import Vuex from 'vuex'
import app from '@/store/modules/app'
import patient from '@/store/modules/patient'
import detailedPatient from '@/store/modules/detailed-patient'
import exercise from '@/store/modules/exercise'
import exerciseProgram from '@/store/modules/exercise-program'
import siteStats from '@/store/modules/site-stats'
import site from '@/store/modules/site'
import unit from '@/store/modules/unit'
import patientNotes from '@/store/modules/patient-note'
import patientWithEvents from '@/store/modules/patient-with-events'
import patientWithSummaryReports from '@/store/modules/patient-with-summary-reports'
import patientWithMappingReports from '@/store/modules/patient-with-mapping-reports'
import patientWithDetailedReports from '@/store/modules/patient-with-detailed-reports'
import patientWithActigraphyReports from '@/store/modules/patient-with-actigraphy-reports'
import patientWithLiveDataLatest from '@/store/modules/patient-with-live-data-latest'
import patientWithStats from '@/store/modules/patient-with-stats'
import watchList from '@/store/modules/watch-list'
import patientWithLatestVisit from '@/store/modules/patient-with-latest-visit'
import patientWithExerciseSummarys from '@/store/modules/patient-with-exercise-summarys'
import shiftReport from '@/store/modules/shift-report'
import unitRoundReport from '@/store/modules/unit-round-report'
import { ModuleNames } from '@/store/module-names'
import siteReadings from '@/store/modules/site-readings'
import monthlyCosts from '@/store/modules/monthly-costs'
import siteDetailed from '@/store/modules/site-detailed'

Vue.use(Vuex)

export const enum RootMutationNames {
  AddApiCall = 'ROOT_ADD_API_CALLS',
  RemoveApiCall = 'ROOT_REMOVE_API_CALLS',
}

export const enum RootActionNames {}

export const enum RootGetterNames {
  GetApiCall = 'ROOT_GET_API_CALL',
}

export interface AgarteeState {
  apiCalls: Record<string, boolean>
}

export default new Vuex.Store<AgarteeState>({
  strict: process.env.NODE_ENV === 'development',
  state: {
    apiCalls: {},
  },
  getters: {
    [RootGetterNames.GetApiCall]: state => id => {
      return state.apiCalls[id] || null
    },
  },
  mutations: {
    [RootMutationNames.AddApiCall](state, payload: string): void {
      state.apiCalls[payload] = true
    },
    [RootMutationNames.RemoveApiCall](state, payload: string): void {
      delete state.apiCalls[payload]
    },
  },
  actions: {},
  modules: {
    [ModuleNames.app]: app,
    [ModuleNames.patient]: patient,
    [ModuleNames.detailedPatient]: detailedPatient,
    [ModuleNames.exercise]: exercise,
    [ModuleNames.exerciseProgram]: exerciseProgram,
    [ModuleNames.siteStats]: siteStats,
    [ModuleNames.siteReadings]: siteReadings,
    [ModuleNames.site]: site,
    [ModuleNames.siteDetailed]: siteDetailed,
    [ModuleNames.unit]: unit,
    [ModuleNames.patientNotes]: patientNotes,
    [ModuleNames.patientWithEvents]: patientWithEvents,
    [ModuleNames.patientWithSummaryReports]: patientWithSummaryReports,
    [ModuleNames.patientWithMappingReports]: patientWithMappingReports,
    [ModuleNames.patientWithDetailedReports]: patientWithDetailedReports,
    [ModuleNames.patientWithActigraphyReports]: patientWithActigraphyReports,
    [ModuleNames.patientWithLiveDataLatest]: patientWithLiveDataLatest,
    [ModuleNames.patientWithStats]: patientWithStats,
    [ModuleNames.watchList]: watchList,
    [ModuleNames.patientWithLatestVisit]: patientWithLatestVisit,
    [ModuleNames.patientWithExerciseSummarys]: patientWithExerciseSummarys,
    [ModuleNames.shiftReport]: shiftReport,
    [ModuleNames.unitRoundReport]: unitRoundReport,
    [ModuleNames.monthlyCosts]: monthlyCosts,
  },
})
